<template>
    <nav class="navbar navbar-expand-lg navbar-light sticky-top bg-light py-4">
        <router-link class="navbar-brand p-0" :to="{ path: '/' }"><img src="@/assets/NewLogo.png" alt="logo"
                height="50"></router-link>

        <!-- Toggle button for mobile view -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse ml-md-5 ml-1" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <!-- Dropdown 1 -->
                <li class="nav-item mx-2 dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="dropdown1" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        GST
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdown1" @click="closeNavbar()">
                        <router-link class="dropdown-item" :to="{ path: 'gst?#individual' }">Individual</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'gst?#private' }">Private</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'gst?#llp' }">LLP</router-link>
                    </div>
                </li>

                <!-- Dropdown 2 -->
                <li class="nav-item mx-2 dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="dropdown2" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        Registrations
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdown1" @click="closeNavbar()">
                        <router-link class="dropdown-item" :to="{ path: 'registrations?#incorporation' }">Incorporation
                            certificate</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'registrations?#trade' }">Trade
                            license</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'registrations?#food' }">Food
                            license</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'registrations?#pf' }">PF</router-link>
                    </div>
                </li>

                <!-- Dropdown 3 -->
                <li class="nav-item mx-2 dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="dropdown3" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        ITR
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdown1" @click="closeNavbar()">
                        <router-link class="dropdown-item" :to="{ path: 'itr?#itr' }">ITR 1</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'itr?#itr' }">ITR 2</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'itr?#tds' }">TDS</router-link>
                    </div>
                </li>

                <!-- Dropdown 4 -->
                <li class="nav-item mx-2 dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="dropdown4" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        Corporate services
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdown1" @click="closeNavbar()">
                        <router-link class="dropdown-item" :to="{ path: 'corporate?#stock' }">Stock audit</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'corporate?#tds' }">Tax audit</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'corporate?#internal' }">Internal
                            audit</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'corporate?#banking' }">Banking
                            services</router-link>
                    </div>
                </li>

                <!-- Dropdown 5 -->
                <li class="nav-item mx-2 dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="dropdown5" role="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        Financial planning
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdown1" @click="closeNavbar()">
                        <router-link class="dropdown-item" :to="{ path: 'financial?#advice' }">Stock
                            advice</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'financial?#planning' }">Year
                            planning</router-link>
                        <router-link class="dropdown-item" :to="{ path: 'financial?#mutual' }">Mutual
                            funds</router-link>
                    </div>
                </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
                <a href="#get-in-touch" class="c-link" @click="closeNavbar()">Get in touch <img
                        src="@/assets/icons/right-arrow.svg" alt="logo" height="20"></a>
                <!-- <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
                <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button> -->
            </form>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'ResponsiveHeader',
    methods: {
        closeNavbar() {
            console.log("close navbar")
            const navbarCollapse = document.querySelector('#navbarSupportedContent');
            if (navbarCollapse && navbarCollapse.classList.contains('show')) {
                navbarCollapse.classList.remove('show');
            }
        },
    }
};
</script>

<style scoped>
/* 
matt blue #102c46
matt green #056251
light green #1eb53b
matt gold #c69064 #e1c493 
*/

.navbar-toggler {
    background: #e0ae7ede;
}

.navbar {
    box-shadow: 0 3px 16px -2px #ebe8e8;
    border-radius: 0px 0px 12px 12px;
}

.bg-light {
    background-color: #102c46 !important;
}

.navbar-brand {
    font-weight: bold;
    color: #333;
}

.nav-link {
    color: #fff !important;
    font-weight: bold;
}

.nav-link:hover {
    color: #056251 !important;
    font-weight: bold;
}

/* Hover dropdown style */
.nav-item {
    color: #fff !important;
}

.nav-item.dropdown:hover .dropdown-menu {
    display: block;
    margin-top: 0;
    border: none;
    border-top: 2px solid #1eb53b;
}

.navbar-light .navbar-toggler {
    border-color: transparent;
}
</style>
